export default {
  messageSendFailure: 'Failed to send. Press to retry.',
  messageBot: 'Bot',
  processingAnswer: 'Processing Answer',
  aiAnswer: 'Generated by an AI bot',
  fromAiAutomation: 'Generated by AI',
};
